// @unocss-include
export default {
  accordion: {
    container: '',
    accordionHeader: 'accordion-header position-relative w-100% flex items-center border-1 border-gray-200 rounded border-rounded-b-0 px-4 py-2',
    accordionHeaderCollapsed: '!border-rounded-b',
    accordionHeaderIcon: 'accordion-icon',
    accordionHeaderIconWrapper: 'position-absolute right-4 flex items-center pl-1',
    accordionHeaderIconCollapsed: 'i-far-chevron-down',
    accordionHeaderIconExpanded: 'i-far-chevron-up',
    accordionHeaderSlotWrapper: 'me-5',
    accordionHeaderSlotIconDefault: 'accordion-icon',
    accordionBody: 'accordion-body border-1 border-t-0 border-gray-200 rounded border-rounded-t-0 p-4',
  },
  accordionFormTemplate: {
    container: '',
    containerDisabled: 'opacity-50 bg-surface-500 text-text-200',
    accordionHeader: 'accordion-header transition-all duration-350 ease-in-out group flex flex-col border-1 rounded px-4 py-3',
    accordionHeaderExpanded: 'bg-secondary-100 border-secondary-200 shadow-sm',
    accordionHeaderCollapsed: 'bg-surface-200 hover:(bg-surface-400) border-surface-700',
    accordionHeaderIconWrapper: 'flex items-center flex-gap-3',
    accordionHeaderIcon: 'i-fas-circle-check mr--1',
    accordionHeaderIconComplete: 'bg-success grow-0',
    accordionHeaderIconIncomplete: 'bg-surface-700',
    accordionHeaderTitle: 'accordion-title group-hover:font-700 grow fw-600 font-sans',
    accordionFormWarningRequired: 'text-sm fw-600 font-sans',
    accordionHeaderChipIcon: 'i-fas-floppy-disk',
    accordionHeaderIconFont: 'fw-900',
    accordionHeaderIconCollapsed: 'i-far-chevron-down',
    accordionHeaderIconExpanded: 'i-far-chevron-up',
    accordionHeaderSubtitle: 'subtitle text-text-200 flex flex-row flex-gap-2 text-sm text-text-400 transition-opacity',
    accordionHeaderSubtitleFont: 'mr-1 fw-600',
    accordionBody: 'accordion-body mt-2 border-1 border-secondary-200 border-rounded bg-surface-200 p-6',

  },
  alertComponent: {
    container: 'alert-container flex flex-col flex-gap-y-4 border-1 rounded p-4',
    warning: 'bg-warning-100 border-warning',
    info: 'bg-info-100 border-info',
    success: 'bg-success-100 border-success',
    danger: '$reset bg-alert-100 border-alert',
    alertContentWrapper: 'flex flex-gap-x-4 flex-gap-y-4 sm:(flex-row)',
    alertContent: 'flex grow self-center items-start flex-gap-x-4 lt-sm:(flex-gap-x-2.5)',
    alertContentSlot: 'text-sm text-text-500 translate-y-0.5',
    alertCtaSlotSmall: 'lt-sm:hidden',
    alertCtaSlotLarge: 'sm:hidden',
    alertCloseIcon: 'i-far-xmark',
    alertCloseButton: 'mb-auto ml-auto flex rounded-2px',
    alertWarningIcon: 'i-fas-circle-exclamation',
    alertWarningHover: 'hover:bg-warning',
    alertInfoIcon: 'i-fas-circle-info',
    alertInfoHover: 'hover:bg-info',
    alertSuccessIcon: 'i-fas-circle-check',
    alertSuccessHover: 'hover:bg-success',
    alertDangerIcon: 'i-fas-circle-xmark',
    alertDangerHover: 'hover:bg-danger',
  },
  asyncButton: {
    body: 'flex flex-row items-center justify-center',
    spinner: 'ms--3',
    text: 'ms-4',
  },
  avatar: {
    container: '',
    avatarTemplate: 'relative flex shrink-0 select-none items-center justify-center overflow-hidden bg-surface-300 bg-cover bg-clip-border bg-center',
    text: 'm-auto font-serif fw-500 text-secondary',
    avatarTemplateSquare: 'rounded',
    avatarTemplateHalfRounded: 'rounded-1/2',
    avatarRingStyleLg: 'ring-4',
    avatarRingStyleMd: 'ring-3',
    avatarRingStyleDefault: 'ring-1',
    avatarBorder: 'ring-surface-600',
    avatarText: 'm-auto font-serif fw-500 text-secondary',
    avatarImage: 'position-absolute object-cover',
  },
  avatarList: {
    container: 'avatars-list flex flex-row p-4',
    avatarListPerson: 'avatar',
    avatarListDualAvatar: 'pt-2',
    avatarListTooltip: '!w-auto mb-1',
    avatarListAvatar: 'mx--1.5',
    avatarListInfo: 'px-4 py-2 text-center text-xs fw-400',
    avatarListEmail: 'fw-300',
    avatarListButtonLg: '-ml-4',
    avatarListButtonMd: '-ml-2',
    avatarListButtonSm: '-ml-1',
    avatarListAvatarClass: 'fw-700',
    avatarListContent: 'max-w-screen min-w-281px rounded-8px bg-surface-100 py-1 shadow-md ring-1 ring-surface-700',
    avatarListContentButton: 'dropdown-list-item',
    avatarListContentAvatar: 'me-2',
    avatarListAvatarDetails: 'flex flex-col items-start',
    avatarListAvatarName: 'text-sm text-text-500',
    avatarListAvatarEmail: 'text-xs text-text-400',
  },
  backdrop: {
    container: 'fixed inset-0 overflow-hidden bg-black/50',
  },
  badge: {
    container: 'absolute right-0 top-0 transform-translate-x-50% transform-translate-y--50% text-xs',
  },
  breadcrumbs: {
    container: '',
    breadCrumbsNav: 'ms--1 flex flex-row items-center justify-start lt-sm:!hidden',
    breadCrumbsChevron: 'i-far-chevron-right mx-1 p-1 text-3 text-secondary-200',
    breadCrumbsMainCrumb: 'breadcrumb cursor-pointer rounded-5px px-2 py-1 text-xs lh-16px text-secondary-300 active:(bg-surface-500 text-secondary) focus:(bg-surface-500 text-secondary) hover:(bg-surface-500 text-secondary) last:(bg-surface-500 text-secondary) !no-underline',
    breadCrumbsPenultimateCrumbNav: 'ms--2 sm:hidden',
    breadCrumbsPenultimateCrumb: 'breadcrumb flex-inline flex-row items-center self-start justify-start rounded-5px px-2 py-1 active:(bg-surface-500 text-secondary) focus:(bg-surface-500 text-secondary) hover:(bg-surface-500 text-secondary) last:(bg-surface-500 text-secondary) !no-underline',
    breadCrumbsIconWrapper: 'icon-box me-1 h-4 w-4 flex items-center justify-center',
    breadCrumbsIcon: 'i-far-chevron-left mx-1 p-1 text-3 text-secondary-200',
    breadCrumbsPenultimateCrumbLabel: 'text-xs lh-16px text-secondary-300',
  },
  button: {
    container: 'cursor-pointer lt-sm:w-full',
  },
  calendar: {
    container: 'w-276px',
    calendarContent: 'calendar-body flex flex-col flex-gap-y-2px',
    calendarWeekdays: 'calendar-weekdays flex flex-row flex-gap-x-1 text-xs fw-semibold text-text-300',
    calendarWeekdayText: 'calendar-weekday w-36px self-center px-1 py-2 text-center',
    calendarWeeks: 'calendar-week flex flex-row flex-gap-x-1 text-xs fw-semibold text-text-300',
    calendarDay: 'calendar-day',
    calendarDayButton: 'calendar-day if-active:bg-secondary-100 !if-disabled:text-text-200 !if-disabled:bg-white size-36px inline-flex flex-1 select-none items-center justify-center rounded-1/2 p-2 text-center text-sm fw-bold text-text-500 hover:bg-secondary-100',
    calendarDateUnderLined: '!w-full !border-b-1',
    calendarDateNotUnderlinedSelected: '!border-primary-100',
    calendarDateNotUnderlined: '!border-primary-400',
    calendarMonthWrapper: 'base-month', // Base classes need to be required in component
    calendarMonth: 'base-month-body mb-4 flex items-center justify-between',
    calendarPreviousMonth: 'calendar-month-prev h-24px w-24px',
    calendarPreviousMonthIcon: 'i-fas-arrow-left',
    calendarPreviousMonthIconStandard: 'text-secondary-100',
    calendarPreviousMonthIconMore: 'text-secondary-400',
    calendarMonthYear: 'base-calendar-month-year flex flex-gap-x-2',
    calendarNextMonth: 'calendar-month-prev h-24px w-24px',
    calendarNextMonthIcon: 'i-fas-arrow-right',
    calendarNextMonthIconStandard: 'text-secondary-100',
    calendarNextMonthIconMore: 'text-secondary-400',
  },
  calendarInput: {
    container: '',
  },
  card: {
    container: '',
    cardInnerContainer: 'flex flex-col flex-gap-y-4 border-1 p-4',
    cardImageContainer: 'overflow-hidden',
    cardHeading: 'text-lg font-semibold',
  },
  checkbox: {
    container: '',
    checkbox: 'cursor-pointer is-[.checked]:(bg-[--theme-checkbox-checked-background] shadow-[--theme-checkbox-checked-background])', // [--theme-checkbox-checked-background]
    checkboxButton: 'inline-block',
  },
  chip: {
    container: 'w-min flex flex-row items-center justify-center whitespace-nowrap border-1 rounded-full px-2 py-0.5 text-xs text-text-500',
    alert: 'bg-alert-100 border-alert',
    danger: 'bg-danger-100 border-danger',
    info: 'bg-info-100 border-info',
    success: 'bg-success-100 border-success',
    warning: 'bg-warning-100 border-warning',
    utility: 'bg-utility-100 border-utility',
    primary: 'bg-primary-100 border-primary',
    secondary: 'bg-secondary-100 border-secondary',
    tertiary: 'bg-tertiary-100 border-tertiary',
    surface: 'bg-surface-100 border-surface-700',
    chipIcon: 'mr-1.5 leading-0',
  },
  clipboard: {
    clipboardIcon: 'ds-clipboard-button__icon i-far-copy duration-150 hover:i-fas-copy',
    clipboardLabel: 'ds-clipboard-button__label mb-0.5 ml-2 text-sm',
    clipboardCopied: 'p-1 color-text-button',
    clipboardCopiedLight: 'text-secondary',
  },
  collapse: {
    container: 'block overflow-hidden transition-max-height duration-500 ease',
  },
  comboboxInput: {
    container: 'h-40px overflow-hidden',
    enter: 'transition duration-100 ease-out',
    enterFrom: 'transform scale-95 opacity-0',
    enterTo: 'transform scale-100 opacity-100',
    leave: 'transition duration-75 ease-out',
    leaveFrom: 'transform scale-100 opacity-100',
    leaveTo: 'transform scale-95 opacity-0',
    field: 'relative h-40px flex rounded bg-white ring-1 ring-surface-700 ring-inset shadow-reset',
    fieldLayout: 'me-8 w-full flex flex-row cursor-default items-center truncate rounded px-4 py-1 text-left text-sm',
    input: 'w-full inline-flex text-gray-900 ring-transparent lt-sm:text-sm !outline-none',
    chevronDownButton: 'absolute inset-y-0 right-0 flex items-center pr-4',
    spinner: 'pr-4 text-text-300',
    valueBox: 'absolute inset-1 z-1 flex flex-row items-center justify-between rounded bg-white px-3 py-1',
    valueBoxLabel: 'block flex flex-row items-center truncate lt-sm:text-sm',
    closeButton: 'touch-target ms-3 flex after:h-36px',
    menu: 'max-h-60 min-w-[inherit] flex flex-col flex-gap-1 overflow-auto rounded bg-white py-1 text-base shadow ring-1 ring-surface-700 lt-sm:text-sm focus:outline-none',
    noResultLabel: 'relative cursor-default select-none px-4 py-2 text-gray-700',
    optionItem: 'combobox-option cursor-default select-none select-none text-text-500 hover:!cursor-pointer',
    optionActive: 'active text-secondary-400 bg-surface-500',
    optionDisabled: 'disabled text-text-200 bg-white',
    optionCustom: 'block flex flex-row items-center truncate px-4 py-1',
  },
  dataPager: {
    container: 'flex',
    dataPagerList: 'flex rounded bg-white shadow-sm',
    dataPagerListItem: 'flex',
    dataPagerFirstPageButton: 'select-none border border-r-0 border-gray-100 rounded-l px-3 py-2 text-sm text-gray-600 no-underline hover:bg-surface-500 disabled:text-text-200',
    dataPagerLastPageButton: 'select-none border border-l-0 border-gray-100 rounded-r px-3 py-2 text-sm text-gray-600 no-underline hover:bg-surface-500 disabled:text-text-200',
    dataPagerChevronLeft: 'i-far-chevron-left',
    dataPagerChevronRight: 'i-far-chevron-right',
    dataPagerPageLabel: 'select-none border border-surface-700 bg-surface-500 px-3 py-2 text-sm color-text-heading no-underline hover:no-underline',
    dataPagerPageLink: 'border border-surface-500 px-3 py-2 text-sm color-text-label hover:bg-surface-500 hover:no-underline',
  },
  dataPagerSummary: {
    container: 'text-sm color-text-400',
    dataPagerSummaryText: 'font-bold',
  },
  dataSorter: {
    container: 'touch-target relative ms-5 h-16px w-16px flex',
    dataSorterIcon: 'm-auto self-center text-12px text-secondary-300',
    dataSorterIconInactive: 'i-fas-sort',
    dataSorterIconAsc: 'i-fas-sort-up',
    dataSorterIconDesc: 'i-fas-sort-down',
    dataSorterBadge: 'flex items-center justify-center b-1 b-rounded-1/2 bg-surface-600 p-2px',
    dataSorterBadgeIcon: 'text-10px',
    dataSorterBadgeIcon1: 'i-fas-1',
    dataSorterBadgeIcon2: 'i-fas-2',
    dataSorterBadgeIcon3: 'i-fas-3',
    dataSorterBadgeIcon4: 'i-fas-4',
    dataSorterBadgeIcon5: 'i-fas-5',
    dataSorterBadgeIcon6: 'i-fas-6',
    dataSorterBadgeIcon7: 'i-fas-7',
    dataSorterBadgeIcon8: 'i-fas-8',
    dataSorterBadgeIcon9: 'i-fas-9',
  },
  dateCalendarInput: {
    container: 'input-date',
    dateCalendarInputEnter: 'transition duration-100 ease-in-out',
    dateCalendarInputEnterFrom: 'transform scale-95 opacity-0',
    dateCalendarInputEnterTo: 'transform scale-100 opacity-100',
    dateCalendarInputLeave: 'transition duration-75 ease-in-out',
    dateCalendarInputLeaveFrom: 'transform scale-100 opacity-100',
    dateCalendarInputLeaveTo: 'transform scale-95 opacity-0',
    dateCalendarInputCalendarIconButton: 'flex grow items-center b-1 border-surface-700 border-rd bg-white px-3 py-2.5',
    dateCalendarInputCalendarIcon: 'i-far-calendar mr-2 text-lg text-secondary-300',
    dateCalendarInputTimeWrapper: 'position-relative text-sm text-text-300',
    dateCalendarInputTime: 'position-relative z-1 select-none whitespace-nowrap',
    dateCalendarInputContent: 'w-fit rounded bg-white p-4 shadow ring-1 ring-surface-700',
    dateCalendarInputButtonRow: 'mt-4 flex flex-gap-x-2',
    dateCalendarInputConfirm: 'flex-1 btn-sm btn-fill-secondary',
    dateCalendarInputCancel: 'flex-1 ring-1 btn-sm btn-outline-secondary',
  },
  dateRangeInput: {
    enterActive: 'transition transform duration-100 ease-out',
    enterFrom: 'opacity-0 scale-90',
    enterTo: 'opacity-100 scale-100',
    leaveActive: 'transition transform duration-100 ease-in',
    leaveFrom: 'opacity-100 scale-100',
    leaveTo: 'opacity-0 scale-90',
    openButton: 'h-40px max-w-full flex items-center justify-between flex-gap-x-1 rounded rounded-4px bg-white px-3 py-2 text-sm ring-1 ring-surface-700 ring-inset shadow-reset focus:outline-none',
    displayValueDetail: 'mt-1 text-left text-xs text-text-500',
    displayValue: 'block truncate text-gray-300 capitalize text-text-500',
    menu: 'rounded bg-white shadow-lg ring-1 ring-surface-700 ring-inset lt-sm:w-235px sm:w-327px relative',
    menuLayout: 'flex flex-col overflow-hidden p-4',
    menuName: 'mb-2 fw-semibold',
    applyButton: 'mt-6 btn-sm text-center btn-fill-secondary',
    rangeForm: 'flex flex-col flex-gap-y-4',
    rangeFormLast: 'flex flex-row flex-gap-x-2',
    rangeFormLastUnit: 'w-150px',
    rangeFormLastUnitOptions: 'lt-sm:max-w-20',
    rangeFormLastQuantityWrapper: 'max-w-61px',
    rangeFormBetween: 'flex justify-between flex-gap-2 sm:(flex-row items-center) lt-sm:(flex-col items-stretch)',
    rangeFormBetweenCalendarInput: 'self-stretch',
    rangeFormBetweenCalendarInputError: '!border-danger',
    rangeFormBetweenAnd: 'text-center text-sm',
  },
  debugInfo: {
    container: 'mt-4 flex flex-col flex-gap-4 border-1 border-surface-600 rounded bg-surface-200 p-3 text-xs text-text-500',
    debugInfoTitle: 'border-b-1 border-surface-600 fw-semibold text-text-400',
    debugInfoOptions: 'flex flex-row flex-wrap flex-gap-2 text-xs',
    debugInfoSingleOption: 'border-1 border-surface-600 rounded bg-surface-500 p-1 px-2',
    debugInfoSingleOptionLabel: 'flex flex-gap-x-1',
    debugInfoDisplayedValues: 'fw-700',
  },
  dropdown: {
    container: 'ds-dropdown',
    dropdownMenuButton: 'ds-dropdown-button min-h-40px flex flex-row select-none items-center justify-between flex-gap-x-4 truncate',
    dropdownLabelSlot: 'truncate',
    dropdownIconSlot: 'ds-dropdown-icon i-far-chevron-down flex-shrink-0 text-sm',
    dropdownEnterActive: 'transition transform duration-100 ease-out',
    dropdownEnterFrom: 'opacity-0 scale-90',
    dropdownEnterTo: 'opacity-100 scale-100',
    dropdownLeaveActive: 'transition transform duration-100 ease-in',
    dropdownLeaveFrom: 'opacity-100 scale-100',
    dropdownLeaveTo: 'opacity-0 scale-90',
    dropdownContent: 'relative',
    dropdownList: 'max-w-250px min-w-150px overflow-hidden rounded-6px bg-white shadow-lg ring-1 ring-surface-700',
    dropdownMenuItems: 'w-full py-1',
    dropdownMenuSingleItem: 'w-full px-4 py-2 text-left text-sm text-text-500 hover:bg-surface-500',
    dropdownMenuItemActive: 'bg-surface-500',
  },
  icon: {
    container: 'inline-flex shrink-0 items-center justify-center',
    iconSizeXs: 'wh-16px text-12px',
    iconSizeSm: 'wh-18px text-16px',
    iconSizeMd: 'wh-24px text-18px',
    iconSizeLg: 'wh-32px text-24px',
    iconSizeXl: 'wh-48px text-36px',
  },
  listboxInput: {
    container: '!block',
    listboxInputEnter: 'transition duration-100 ease-out',
    listboxInputEnterFrom: 'transform scale-95 opacity-0',
    listboxInputEnterTo: 'transform scale-100 opacity-100',
    listboxInputLeave: 'transition duration-75 ease-out',
    listboxInputLeaveFrom: 'transform scale-100 opacity-100',
    listboxInputLeaveTo: 'transform scale-95 opacity-0',
    listboxInputButton: 'listbox-button h-40px w-full flex flex-row cursor-default items-center justify-between flex-gap-x-2 rounded bg-white py-2 text-left shadow-none lt-sm:text-sm',
    listboxInputButtonRinged: 'px-4 ring-1 ring-surface-700 ring-inset',
    listboxInputButtonRingless: 'px-0',
    listboxInputButtonContent: 'block truncate',
    listboxInputButtonContentEmpty: 'text-gray-400',
    listboxInputButtonIcon: 'pointer-events-none ms-3 flex items-center',
    listboxInputButtonIconDefault: 'i-far-chevron-down text-lg text-secondary',
    listboxInputOptions: 'listbox-options max-h-60 min-w-[inherit] flex flex-col flex-gap-1 overflow-auto rounded bg-white py-1 text-base shadow ring-1 ring-surface-700 lt-sm:text-sm focus:outline-none',
    listboxInputSingleOption: 'cursor-default select-none text-text-500 disabled:text-text-200 bg-white',
    listboxInputOptionSelected: 'text-secondary-400 bg-surface-600 fw-medium',
    listboxInputOptionActive: 'text-secondary-400 bg-surface-500',
    listboxInputOptionSlot: 'flex flex-row items-center px-3 py-2',
    listboxInputOptionSlotLabel: 'block truncate',
  },
  loadingWrapper: {
    container: 'bg-white/75',
  },
  modal: {
    container: 'ds-modal z-modal fixed bottom-0 left-0 right-0 top-0 flex lt-sm:(mx-4 my-4) sm:(mx-auto mt-10)',
    modalEnter: 'duration-300 ease-out',
    modalEnterFrom: 'opacity-0',
    modalEnterTo: 'opacity-100',
    modalLeave: 'duration-200 ease-in',
    modalLeaveFrom: 'opacity-100',
    modalLeaveTo: 'opacity-0',
    modalDialogOverlay: 'dialog-overlay position-fixed bottom-0 left-0 right-0 top-0 bg-gray-400 opacity-50',
    modalLoadingEnter: 'duration-300 ease-out',
    modalLoadingEnterFrom: 'opacity-0 scale-95',
    modalLoadingEnterTo: 'opacity-100 scale-100',
    modalLoadingLeave: 'duration-200 ease-in',
    modalLoadingLeaveFrom: 'opacity-100 scale-100',
    modalLoadingLeaveTo: 'opacity-0 scale-95',
    modalDialogPanel: 'position-relative m-auto border-1 border-gray-400 rounded-4px bg-surface-200 shadow-lg focus:outline-0',
    modalClose: 'btn-close position-absolute right-6 top-4 box-border flex border-0 rounded bg-transparent text-8',
    modalCloseIcon: 'i-far-xmark text-gray-800',
  },
  notifier: {
    container: 'flex flex-col flex-gap-y-4',
    notifierEnter: 'transition-opacity,transform duration-500',
    notifierEnterFrom: 'opacity-0 translate-x-500px',
    notifierEnterTo: 'opacity-100 translate-x-0',
    notifierLeave: 'transition-opacity,transform duration-1000',
    notifierLeaveFrom: 'opacity-100 translate-x-0',
    notifierLeaveTo: 'opacity-0 translate-x-500px',
    danger: '$reset bg-alert-100 border-alert',
    info: 'bg-info-100 border-info',
    success: 'bg-success-100 border-success',
    warning: 'bg-warning-100 border-warning',
    utility: 'bg-utility-100 border-utility',
    notifierToastWrapper: 'toast border-1 rounded shadow-sm',
    notifierToast: 'toast-wrapper p-4 pb-6',
    notifierDangerIcon: 'absolute right-4',
    notifierToastHeader: 'toast-header flex justify-between',
    notifierTitleIconBoxWrapper: 'flex',
    notifierTitleIconBox: 'icon-box h-24px w-24px flex flex-shrink-0 items-center self-start justify-center',
    notifierToastClose: 'i-far-xmark',
    notifierTitleIconDanger: 'i-fas-circle-xmark',
    notifierTitleIconInfo: 'i-fas-circle-info',
    notifierTitleIconSuccess: 'i-fas-circle-check',
    notifierTitleIconWarning: 'i-fas-circle-exclamation',
    notifierTitleIconUtility: 'i-fas-square-info',
    notifierTitleIcon: 'm-auto text-18px color-text-500',
    notifierTitle: 'pl-2 font-serif text-base font-medium color-text-500',
    notifierContent: 'mt-2 font-sans text-lg color-text-500',
  },
  numberInput: {
    numberInputContainer: 'flex flex-col items-center',
    numberInputButton: 'h-40px w-full flex items-center justify-center',
    numberInputInput: 'h-40px w-52px flex flex-row cursor-default items-center justify-between flex-gap-x-2 rounded bg-white px-2 py-2 text-center shadow-none ring-1 ring-surface-700 ring-inset lt-sm:text-sm',
  },
  offCanvas: {
    container: '',
    offCanvasEnter: 'transition-transform,width ease-in-out duration-350',
    offCanvasEnterFrom: 'translate-x--100%',
    offCanvasEnterTo: 'translate-x-0',
    offCanvasLeave: 'transition-transform,width ease-in-out duration-350',
    offCanvasLeaveFrom: 'translate-x-0',
    offCanvasLeaveTo: 'translate-x--100%',
    offCanvasContent: 'offcanvas-inner fixed bottom-0 left-0 top-0 z-201 w-fit flex flex-col overflow-hidden b-r-1 b-black/50 shadow-lg',
  },
  personComboboxInput: {
    optionLayout: 'flex flex-row items-center',
    optionLabel: 'flex flex-col',
    optionName: 'text-sm text-text-500',
    optionEmail: 'text-xs text-text-400',
  },
  popup: {
    container: 'inline-block',
    popupButton: 'ds-popup-button-wrapper',
  },
  progressBar: {
    container: 'border-box m0 flex flex-col items-center p0 text-14px text-#606266',
    text: 'font-base mt-2 font-serif text-left inline-block ml-10px',
    outer: 'border-box vertical-align-middle inline-block w-full',
    outerLine: 'rounded-xl bg-brand relative rounded-100px transition-property-all transition-duration-750 transition-ease transition-delay-0',
    outerLineActive: 'bg-white rounded-10px h-inherit align-middle break-keep opacity-20',
    barBg: 'rounded-xl bg-#EBEDF0',
  },
  radio: {
    container: 'cursor-pointer',
  },
  rating: {
    container: 'w-fit cursor-pointer px-8 py-4 text-brand',
    ratingStar: 'i-fas-star-sharp',
    ratingStarL: 'i-fal-star-sharp',
    ratingHalfStar: 'i-fas-star-sharp-half-stroke',
  },
  spinner: {
    container: '',
    spinnerInline: 'spinner-inline',
    spinnerBlock: 'spinner-block absolute bottom-0 left-0 right-0 top-0 w-full flex',
    spinnerBlockInner: 'h-full w-full',
  },
  switch: {
    container: 'flex',
    switchButtonWrapper: 'flex items-center flex-gap-x-2',
    switchButtonWrapperReverse: 'flex-row-reverse',
    switchButton: 'base-switch s-2 relative h-5 w-9 inline-flex shrink-0 items-center rounded-full ring-1 transition-colors transition-colors',
    switchButtonChecked: 'bg-success-400 ring-success-400',
    switchButtonUnchecked: 'bg-surface-500 ring-surface-700',
    switchToggle: 'inline-block h-4 w-4 transform rounded-full bg-white transition-transform',
    switchToggleChecked: 'translate-x-4.5',
    switchToggleUnchecked: 'translate-x-0.5 ring-1 ring-inset ring-surface-700',
    switchLabel: 'cursor-pointer',
  },
  stepper: {
    containerMobile: 'mobile sm:hidden',
    currentStepMobileWrapper: 'flex flex-row items-center flex-gap-x-2 rounded bg-surface-200 p-2 ring-1 ring-surface-600',
    currentStepMobile: 'max-w-1/2 text-xs text-secondary fw-semibold',
    progressBarMobileWrapper: 'progress-bar relative h-6px flex-grow',
    progressBarMobile: 'absolute h-full w-full rounded bg-surface-600',
    currentStepIndexMobile: 'absolute h-full rounded bg-secondary-300',
    currentStepIndexMobileComplete: 'w-full',
    currentStepIndexMobileIncomplete: 'w-38',
    roundedMobile: 'rounded-44px bg-secondary-100 px-2 text-xs fw-semibold ring-1 ring-secondary-200',
    containerDesktop: 'mobile lt-sm:hidden',
    stepsWrapper: 'flex gap-x-3',
    steps: 'step flex flex-grow flex-col gap-y-2.5',
    stepsCircleWrapper: 'flex flex-grow flex-row items-center',
    stepsCircle: 'circle me-4 h-8 w-8 flex flex-shrink-0 items-center justify-center rounded-full ring-1 ring-inset',
    stepsCircleWithBgSecondary: 'bg-secondary-100 ring-secondary-200',
    stepsCircleWithBgSurface: 'bg-surface-500 ring-surface-600',
    stepsCircleInner: 'circle-inner h-4 w-4 flex items-center justify-center',
    stepsRounded: 'h-3 w-3 rounded-full bg-surface-600',
    stepsRoundedIncomplete: 'h-3 w-3 rounded-full bg-secondary-200',
    stepsRoundedComplete: 'i-far-check text-xs text-secondary-300',
    smallText: 'text-xs font-semibold',
    smallTextMissing: 'text-text-200',
    smallTextIncomplete: 'text-secondary-300',
    smallTextComplete: 'text-secondary',
    progressBar: 'progress-bar relative h-1.5',
    rounded: 'absolute h-full w-full rounded bg-surface-600',
    roundedInner: 'absolute h-full rounded bg-secondary-300',
    roundedInnerIncomplete: 'w-9',
    roundedInnerComplete: 'w-full',
  },
  tabBar: {
    container: 'w-100% border-1 border-surface-700 border-rd',
    tabBarTwoOptions: 'flex pa-2 flex-nowrap overflow-auto wa justify-between flex-gap-1',
    tabBarSingleOptions: 'flex pa-2 flex-nowrap overflow-auto',
    tabBarTabTwoOptions: 'w-100%',
    tabBarTabActive: 'bg-surface-600 !fw-600 !text-secondary',
    tabBarButtonDisabled: 'mr-1 flex items-center truncate border-rd pa-2 px-3 text-sm fw-500 color-text-200',
    tabBarButtonTwoOptions: 'pa-2 w-100% justify-center align-center',
    tabBarButtonDisabledIcon: 'mr-2',
    tabBarButton: 'mr-1 flex items-center truncate border-rd pa-2 px-3 text-sm fw-500 color-text-400 hover:(bg-surface-300 underline)',
    tabBarButtonLabelTwoOptions: 'text-center',
    tabBarButtonIcon: 'mr-2',
  },
  table: {
    container: 'w-full border-separate border-spacing-0 ring-0.5px ring-surface-600 rounded-2 first:[&_th]:first:[&_tr]:rounded-tl-2 first:[&_td]:first:[&_tr]:rounded-tl-2 last:[&_th]:first:[&_tr]:rounded-tr-2 last:[&_td]:first:[&_tr]:rounded-tr-2 first:[&_th]:last:[&_tr]:rounded-bl-2 first:[&_td]:last:[&_tr]:rounded-bl-2 last:[&_th]:last:[&_tr]:rounded-br-2 last:[&_td]:last:[&_tr]:rounded-br-2',
    table: 'w-full',
    tableContainerScrollable: 'overflow-x-auto',
    tableScrollable: 'mb-3 border-b-1 border-surface-700 rounded',
    tableStriped: 'striped',
  },
  tableCell: {
    container: 'p-4 text-sm text-text-500 ring-0.5px ring-inset ring-surface-600',
    cellContainer: 'flex items-center justify-between',
  },
  tableHeader: {
    container: 'bg-secondary-100 p-4 text-start h5 ring-0.5px ring-inset ring-surface-600 shadow-lg top-0 z-10',
    tableHeader: 'flex items-center justify-between whitespace-nowrap left-0 z-2',
  },
  tableRow: {
    container: 'odd:bg-surface-300 even:bg-white',
  },
  timeInput: {
    timeInputEnter: 'transition duration-100 ease-in-out',
    timeInputEnterFrom: 'transform scale-95 opacity-0',
    timeInputEnterTo: 'transform scale-100 opacity-100',
    timeInputLeave: 'transition duration-75 ease-in-out',
    timeInputLeaveFrom: 'transform scale-100 opacity-100',
    timeInputLeaveTo: 'transform scale-95 opacity-0',
    timeInputDisplay: 'flex items-center justify-center',
    timeInputContainer: 'w-full',
    timeInputContent: 'w-fit rounded bg-white px-4 py-2 shadow ring-1 ring-surface-700 flex items-center justify-center gap-4',
    timeInputNumberInputContainer: 'flex items-center justify-center gap-1',
    timeInputPeriodContainer: 'flex flex-col gap-2',
    timeInputPeriodButton: 'btn-sm min-h-30px min-w-40px flex items-center justify-center p-0',
    timeInputPeriodButtonInactive: 'btn-fill-secondary',
    timeInputPeriodButtonActive: 'btn-outline-surface-700 text-text-500',
  },
  tooltip: {
    container: 'ds-tooltip flex',
    tooltipButton: 'max-w-fit inline-flex',
    tooltipButtonIcon: 'self-center',
    tooltipButtonSlotDefault: 'i-far-circle-info inline-flex self-center',
    tooltipButtonSlotDefaultSmallText: 'text-sm m-2px',
    tooltipButtonSlotDefaultLargeText: 'text-lg m-3px',
    tooltip: 'max-w-295px rounded rounded-6px font-sans text-xs fw-400 drop-shadow',
    tooltipArrow: 'absolute z--1 h-5 w-5 rotate-45 rounded',
    tooltipBorder: 'border-2',
    tooltipSlot: 'relative overflow-hidden',
    tooltipContent: 'rounded px-4 py-2',
    // Tooltip has computed color classes controlled by props
    tooltipBgColorClassComputedLight: 'bg-secondary-100',
    tooltipBgColorClassComputedDark: 'bg-secondary',
    tooltipBorderColorClassComputed: 'border-secondary-300',
    tooltipBorderColorClassComputedDefault: 'border-transparent',
    tooltipTextColorClassComputedLight: 'text-secondary',
    tooltipTextColorClassComputedDark: 'text-white',
  },
  dataTable: {
    container: 'border-1 border-surface-600 rounded',
    dataTableScrollableContainer: 'scrollbar-track-color-white scrollbar-h-7px scrollbar-radius-4 scrollbar-w-7px scrollbar scrollbar-rounded relative max-h-90vh w-full ring-0.5px ring-inset ring-surface-600 rounded',
    dataTableScrollable: '!overflow-x-scroll mb-0.5 mr-0.5 max-w-[calc(100vw-64px)]',
    dataTableLoadingWrapper: 'min-h-400px',
    dataTableSelectableCell: 'p-4 left-0 z-2 w-0%',
  },
}
